// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1RUp9","col":"styles_col__2lXRQ"};